module.exports = __webpack_public_path__ + "static/media/2 (25).9b3e2e6d.jpg";